export default __webpack_public_path__ + "static/media/grids.8536f48d.webp";